<template>
  <div class="hero mt-5">
    <div class="container">
      <!-- <div style="border: none; border-top: 3px dashed #c2c1bf;" /> -->

      <div class="row">
        <div class="col-md-6 content-container">
          <div class="content-section">
            <h2>Comprehensive Care for All</h2>
            <p>
              Simplify healthcare management with our all-in-one platform for
              easy access to appointments, medications, and vital information.
            </p>
          </div>

          <!-- Personalized User Experience Section -->
          <div class="content-section">
            <h2>Personalized User Experience</h2>
            <p>
              Personalized care that adapts to your loved one’s unique needs,
              providing comfort and peace of mind.
            </p>
          </div>

          <!-- Cognitive Skill Improvement Section -->
          <div class="content-section">
            <h2>Cognitive Skill Improvement</h2>
            <p>
              Boost cognitive health with engaging exercises designed to enhance
              mental sharpness and improve quality of life.
            </p>
          </div>
        </div>
        <div class="col-md-6 text-hero ">
          <h2 style="margin-top: 10px">
            <span style="color: black">Why </span
            ><span style="color: #e2b6ff">HeartBeatFam?</span>
          </h2>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Comprehensive Care for All </strong>
          </p>
          <p>
            Our user-friendly app simplifies the intricate task of managing
            healthcare for individuals of all ages and needs. We provide a
            central platform for all healthcare information, appointments,
            medications, and more.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Enhanced Communication</strong>
          </p>
          <p>
            Stay connected with healthcare providers, caregivers, and family
            members through secure messaging and coordination tools. Keep
            everyone involved, fostering a collaborative approach to care and
            family communication.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Cognitive Skill Improvement</strong>
          </p>
          <p>
            Empower patients to improve their cognitive skills through a range
            of interactive exercises and activities available on the
            HeartBeatFam platform. Strengthen mental acuity and enhance quality
            of life.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Comprehensive Health Records</strong>
          </p>
          <p>
            Access crucial health records and information at your fingertips.
            Monitor health trends, vital signs, and lab results to make
            well-informed decisions about your loved one's care.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Personalized User Experience</strong>
          </p>
          <p>
            Experience a tailored approach to care and well-being. The
            HeartBeatFam platform adapts to the unique needs of your loved ones,
            whether they are seniors, individuals with disabilities, or anyone
            else in need of care. Enjoy a personalized journey that prioritizes
            their comfort and well-being.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FosterSupport"
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: 452px;
  background-color: #ffffff;
  font-family: "Lato";
  .container {
    .text-hero {
      min-height: 452px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      h2 {
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 44px;
        color: #474d52;
        margin-bottom: 20px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
      }
      .btn {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.1em;
        text-transform: capitalize;
      }
    }
    .img-hero {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
      }
    }
    .content-container {
      padding: 50px;
      display: flex;
      flex-direction: column;
      gap: 40px;

      .content-section {
        h2 {
          font-size: 32px;
          font-weight: bold;
          color: #5e2ca5; /* Adjust the color to match your theme */
        }
        p {
          font-size: 20px;
          color: #333;
        }
      }
    }
  }
}
@media (max-width: 640px) {
  .hero {
    .container {
      .text-hero {
        min-height: unset;
        padding-top: 30px;
        padding-bottom: 60px;
        h1 {
          font-size: 60px !important;
          line-height: 70px !important;
        }
      }
      .img-hero svg {
        height: 280px;
        margin: 40px 0;
      }
    }
  }

  .how-to-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 100px;
    gap: 24px;

    position: absolute;
    width: 358px;
    height: 72px;
    left: 541px;
    top: 96px;

    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }
}
</style>
